import { IUpsellRule } from '../../interfaces';

const BORDER_RADIUS_BIG = '0.25rem';
const BORDER_RADIUS_SMALL = '2px';

export interface IMilestone {
    id: string;
    width: string;
    borderRadius: string;
    isPassed: boolean;
    upsellRule?: IUpsellRule;
    isLast: boolean;
}

export class UpsellType2ProgressBarMilestones {
    private readonly _upsellRules: IUpsellRule[];
    private readonly _userHasCount: number;
    private readonly _circleIndexes: number[];

    constructor(
        upsellRules: IUpsellRule[],
        userHasCount: number
    ) {
        this._upsellRules = upsellRules;
        this._circleIndexes = this._upsellRules.map(rule => rule.pluginQuantity);
        this._userHasCount = userHasCount;
    }

    get milestonesCount(): number {
        if(this._upsellRules.length <= 0) return 0;
        return this._upsellRules[this._upsellRules.length - 1].pluginQuantity;
    }

    get milestones() : IMilestone[] {
        const milestones: IMilestone[] = [];

        const milestonesCount = this.milestonesCount;
        const milestoneWidth = 100 / milestonesCount;

        for(let i=0; i<milestonesCount; i++) {

            const isFirst = i === 0;
            const top = isFirst ? BORDER_RADIUS_BIG : BORDER_RADIUS_SMALL;
            const right = BORDER_RADIUS_SMALL;
            const bottom = BORDER_RADIUS_SMALL;
            const left = isFirst ? BORDER_RADIUS_BIG : BORDER_RADIUS_SMALL;
            const borderRadius = `${ top } ${ right } ${ bottom } ${ left }`;

            milestones.push({
                id: `milestone-${ i }`,

                width: `${ milestoneWidth }%`,
                borderRadius,

                isPassed: this._userHasCount > i,
                isLast: i === milestonesCount - 1,
            });
        }

        return milestones;
    }

    public shouldShowCircle(index: number) : boolean {
        return this._circleIndexes.includes(index + 1) || index === this.milestonesCount - 1;
    }

    public getUpsellRule(index: number) : IUpsellRule|undefined {
        return this._upsellRules.find(item => item.pluginQuantity === index);
    }
}